import { configureStore } from '@reduxjs/toolkit'
import themeReducer from './features/theme/themeSlice'
import userReducer from './features/user/userSlice'
import navigationReducer from './features/navigation/navigationSlice'

export const store = configureStore({
  reducer: {
    theme: themeReducer,
    user: userReducer,
    navigation: navigationReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

// 导出hooks
import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux'

export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector